import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const CASES = [
  {
    tag: "Setor: Siderúrgico",
    quote:
      "Contratamos a HSE para uma parada crítica de manutenção com trabalhos em altura, espaço confinado e resgate técnico em prontidão. Planejamento impecável, equipe qualificada e zero incidente na operação.",
    author: "Gerente de Manutenção",
    company: "Indústria Siderúrgica de grande porte",
  },
  {
    tag: "Setor: Química",
    quote:
      "A equipe HSE conduz nossos treinamentos NR 33 e NR 35, além de fornecer bombeiros civis e resgate em plantas químicas. Excelente domínio técnico e postura preventiva. Referência para nossos padrões de SSMA.",
    author: "Coordenadora de SSMA",
    company: "Petroquímica multinacional",
  },
  {
    tag: "Setor: Papel e Celulose",
    quote:
      "A HSE realizou a instalação e certificação de linhas de vida em toda nossa cobertura industrial, incluindo laudo técnico com ART. Trabalho de altíssima qualidade e conformidade com a NR 35.",
    author: "Engenheiro de Segurança",
    company: "Planta industrial de papel e celulose",
  },
  {
    tag: "Setor: Saneamento",
    quote:
      "Serviços de manutenção em reservatórios e limpeza técnica em espaço confinado com vigias e monitoramento atmosférico. Prontidão, disciplina operacional e comunicação clara em todas as etapas.",
    author: "Supervisor de Operações",
    company: "Concessionária de saneamento",
  },
  {
    tag: "Setor: Alimentos e Bebidas",
    quote:
      "A HSE nos apoia em serviços críticos de manutenção industrial e paradas programadas. Sempre com equipes especializadas em alpinismo industrial e proteções de máquinas.",
    author: "Gerente de Facilities",
    company: "Fabricante de bebidas",
  },
  {
    tag: "Setor: Eventos e Operações",
    quote:
      "Contratamos a prontidão com bombeiro civil e unidade de resgate para eventos corporativos com atividades em altura. Serviço executado com profissionalismo, análise de risco robusta e ótima comunicação.",
    author: "Diretor de Operações",
    company: "Operadora de eventos técnicos",
  },
];

export const Cases = () => {
  return (
    <section id="cases" data-testid="section-cases" className="relative py-24 sm:py-32 bg-[#0B1B2D]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="inline-flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#2FA36B]" />
              <span className="font-condensed uppercase text-xs tracking-[0.4em] text-[#2FA36B] font-bold">Cases & Depoimentos</span>
            </div>
            <h2 className="font-condensed font-bold uppercase text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95] tracking-tight">
              Resultados de <span className="text-[#2FA36B]">operações críticas</span>.
            </h2>
          </div>
          <p className="lg:col-span-5 text-white/65 font-body text-base leading-relaxed">
            Depoimentos de gestores que atuam com a HSE em operações industriais de alto risco. Nomes preservados por acordo de confidencialidade.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/[0.07] border border-white/[0.07]">
          {CASES.map((c, i) => (
            <motion.div
              key={i}
              data-testid={`case-card-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}
              className="bg-[#12283F] p-7 sm:p-8 flex flex-col relative"
            >
              <Quote size={28} className="text-[#2FA36B] mb-4" strokeWidth={1.5} />
              <p className="font-body text-white/85 text-sm leading-relaxed mb-6 flex-1">
                &ldquo;{c.quote}&rdquo;
              </p>
              <div className="border-t border-white/10 pt-4">
                <p className="font-condensed font-bold uppercase text-sm text-white tracking-tight">{c.author}</p>
                <p className="font-body text-xs text-white/55">{c.company}</p>
                <p className="mt-2 font-condensed uppercase text-[10px] tracking-[0.25em] text-[#2FA36B] font-bold">{c.tag}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href="#contato"
            data-testid="cases-cta"
            className="inline-flex items-center gap-3 font-condensed uppercase text-sm tracking-[0.2em] font-bold bg-[#2FA36B] hover:bg-[#37B87A] text-white px-8 py-5 transition-colors"
          >
            Quero uma proposta para minha operação
          </a>
        </div>
      </div>
    </section>
  );
};

export default Cases;
